export class DisplayDate {
  public day: string;
  public month: string;
  public year: string;
}
